import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

export const AskQOk = 1
export const AskQCancel = -1
export const AskQNotPressed = 0
export const AskQClosed = -2

interface IAskQ {
  title: string;
  text: string;
  btnOk?: boolean,
  btnOkText?: string,
  btnCancel?: boolean,
  btnCancelText?: string,
  setOk?: React.Dispatch<React.SetStateAction<boolean>> | null;
  setCancel?: React.Dispatch<React.SetStateAction<boolean>> | null;
  setAskQ?: React.Dispatch<React.SetStateAction<number>> | null; 
  askQ?: number
}

export const AskQ = ({title, text, setAskQ, btnOk = true, btnCancel = true, btnOkText = "ДА", btnCancelText = "НЕТ", askQ = AskQNotPressed}: IAskQ) => {
  const [show, setShow] = useState(askQ == AskQNotPressed);

  const handleCancel = () => {
    if(setAskQ != null) setAskQ(AskQClosed)
    setShow(false);
  }
  const handleOk = () => {
    if(setAskQ != null) setAskQ(AskQOk)
    setShow(false);
  }

  useEffect(() => {
    setShow(askQ == AskQNotPressed)
  }, [askQ])

  //if(!show) return <></>
  return (
    <>
    <Modal show={show} onHide={handleCancel} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{text}</Modal.Body>
      <Modal.Footer>
        {btnOk ? <Button variant="success" size="sm" onClick={handleOk}>{btnOkText}</Button> : <></>}
        {btnCancel ? <Button variant="outline-danger" size="sm" onClick={handleCancel}>{btnCancelText}</Button> : <></>}
      </Modal.Footer>
    </Modal>
    </>
  );
};
